import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, inject, viewChild } from '@angular/core';
import '@arcgis/map-components/components/arcgis-locate';
import { openElviaToast } from '@elvia/elvis-toast';

@Component({
  selector: 'app-locate-user-button',
  templateUrl: './locate-user-button.component.html',
  host: {
    class: 'floating-box e-p-8',
  },
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LocateUserButtonComponent {
  private readonly liveAnnouncer = inject(LiveAnnouncer);

  private readonly arcgisLocateElementRef =
    viewChild.required<ElementRef<HTMLArcgisLocateElement>>('arcgisLocate');

  protected onArcgisPropertyChange() {
    const state = this.arcgisLocateElementRef().nativeElement.state;
    if (state !== 'locating') return;

    void this.liveAnnouncer.announce('Finner posisjonen din.', 'polite');
  }

  protected toggleLocate() {
    const arcgisLocate = this.arcgisLocateElementRef().nativeElement;

    if (arcgisLocate.state === 'locating') {
      void arcgisLocate.cancelLocate();
      void this.liveAnnouncer.announce('Søk etter posisjonen din er avbrutt.', 'polite');
      return;
    }

    void arcgisLocate.locate();
  }

  protected onArcgisSuccess() {
    void this.liveAnnouncer.announce('Posisjonen din vises i kartet.', 'polite');
  }

  protected onArcgisError() {
    openElviaToast({
      body: 'Vi fant ikke posisjonen din.',
      closable: true,
      status: 'informative',
    });
  }
}
